<div class="chart" [class.--half-veil]="stations?.length" [class.--straight__border__top]="windSpeedAlertLevels">
    <!-- Mensaje de datos vacíos -->
    <app-empty-data [display]="!data?.length" [text]="'NO_DATA' | translate"></app-empty-data>

    <!-- Sección de información de precipitaciones -->
    <ng-container *ngIf="precipitationLast1h || precipitationLast24h">
        <div class="station__content__card">
            <ion-card class="station__content__card__summary">
                <img alt="Rain Icon" src="assets/images/rain.png" />
                <div class="station__content__card__summary__values">
                    <ng-container *ngIf="precipitationLast1h">
                        <div class="station__content__card__summary__value">
                            <p class="station__content__card__summary__title --h1" [innerHTML]="precipitationLast1h"></p>
                            <p
                                class="station__content__card__summary__subtitle --h3 prec"
                                [innerHTML]="'STATION_PAGE.PRECIPITATION_ACCUMULATED_1H' | translate"
                            ></p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="precipitationLast24h">
                        <div class="station__content__card__summary__value">
                            <p class="station__content__card__summary__title --h1" [innerHTML]="precipitationLast24h"></p>
                            <p
                                class="station__content__card__summary__subtitle --h3 prec"
                                [innerHTML]="'STATION_PAGE.PRECIPITATION_ACCUMULATED_24H' | translate"
                            ></p>
                        </div>
                    </ng-container>
                </div>
            </ion-card>
        </div>
    </ng-container>

    <!-- Canvas para el gráfico -->
    <canvas #chartContainer></canvas>

    <!-- Selector de estaciones (se muestra solo si existen estaciones) -->
    <ng-container *ngIf="stations?.length">
        <div [formGroup]="form">
            <ion-select
                appInputErrors
                class="station-select-standalone"
                formControlName="station"
                interface="popover"
                name="station"
                [cancelText]="'CANCEL' | translate"
                [placeholder]="'SELECT' | translate"
                (ionChange)="selectStation.emit($event.detail.value)"
            >
                <ion-select-option *ngFor="let station of stations; trackBy: trackByStationId" [value]="station.id">
                    {{ station.id + " - " + station.name }}
                </ion-select-option>
            </ion-select>
        </div>
    </ng-container>
</div>
